import { h, JSX } from 'preact'
import { Message } from '../../../../../lib/intl/Message'
import styles from './Tooltip.module.css'

export function Tooltip({ messageId, modifiers }: { messageId: string; modifiers: any }) {
  return (
    <div class={styles.tooltip}>
      <span class={styles.tooltipText}>
        <Message id={messageId} modifiers={modifiers} />
      </span>
      <span class={styles.tooltipArrow}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15">
          <path fill="#26292A" fill-rule="evenodd" d="M7.5 14.5L.5.5h14z" />
        </svg>
      </span>
    </div>
  )
}
